import * as Sentry from '@sentry/react';

import login from "../services/login";
import fetchContext from "../services/context";
import fetchTranslations from "../services/translations";
import {StatusEnum} from "../models/enums/status.enum";
import {UNASSIGNED_ERROR} from "../constants/error";
import {PairingInformations} from "../models/pairing-informations.ts";
import {ContextDTO} from "../models/dto/context-dto.ts";

export interface InitialiseApplicationResult {
  context: ContextDTO
  messages: Record<string, string>
  status: StatusEnum
  pairingInformation?: PairingInformations
}

export const initApp = async (): Promise<InitialiseApplicationResult> => {
    try {
        const hash = window.location.hash.substring(1);
        const urlParams = new URLSearchParams(hash);
        const params = Object.fromEntries(urlParams.entries());

        if (params.deviceId && params.serial && params.apiKey) {
            localStorage.setItem("apiKey", params.apiKey);
            localStorage.setItem("deviceId", params.deviceId);
            localStorage.setItem("serial", params.serial);
        }

        if (!(localStorage.getItem("apiKey") && localStorage.getItem("deviceId") && localStorage.getItem("serial"))) {
            throw new Error("Missing fragment parameters");
        }

        const loginData = await login();
        if (loginData.status === StatusEnum.UNASSIGNED) {
            throw new Error(UNASSIGNED_ERROR);
        }
        localStorage.setItem("jwt", loginData.token);

        Sentry.setContext('context', {serial: localStorage.getItem("serial")});

        const context = await fetchContext();

        const language = context.customerDefaultLanguage;
        const messages = await fetchTranslations(language);

        const pairingInformation = loginData.code && loginData.codeExpiration ? { code: loginData.code, codeExpiration: loginData.codeExpiration } : undefined;

        return { context, messages, status: loginData.status, pairingInformation };
    } catch (error) {
        console.error(error);
        throw new Response(error as BodyInit);
    }
}
